<template>
  <Card :btnMsg="$t('uploadPic.btn_text')" @changeStep="changeStep">
    <div class="card-uploadPic">
      <div class="card-content">
        <p class="card-title" v-html="$t('uploadPic.title')"></p>
        <div class="card-text" v-html="$t('uploadPic.text')"></div>
        <div class="upload-container">
          <div class="upload-box">
            <van-uploader v-if="fileList.length < 2" v-model="fileList" multiple progress :max-count="2">
              <div class="upload-btn">
                <img :src="addPic" />
                <div class="upload-btn-text">{{ $t('uploadPic.add_pic') }}</div>
              </div>
            </van-uploader>
            <div v-else class="upload-btn upload-btn--disabled">
              <img :src="addPic" />
              <div class="upload-btn-text">{{ $t('uploadPic.add_pic') }}</div>
            </div>
            <div class="upload-text">{{ $t('uploadPic.add_pic_text') }}</div>
          </div>
          <div class="review-upload" v-if="fileList.length >= 1">
            <div class="review-upload-pic" v-for="(item, idx) in fileList" :key="item">
              <img :src="item.content" @click="previewPic(item.content)" />
              <van-icon name="cross" @click="deletePic(idx)" />
            </div>
          </div>
          <div class="review-upload" v-else>
            <div class="review-upload-pic">
              <div class="example">{{ $t('example') }}</div>
              <img :src="examplePic" @click="previewPic(examplePic)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from '@/components/card.vue';
import { Dialog } from 'vant';
import { postUploadPic } from '@/api/portal';
import { ImagePreview } from 'vant';
import { postSubmit } from '@/api/portal';

export default {
  components: {
    Card,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
      fileList: [],
      examplePic: require('@/assets/example_upload.jpg'),
      addPic: require('@/assets/add-pic.png'),
    };
  },
  mounted() {
    this.form = this.value;
  },
  methods: {
    deletePic(idx) {
      this.fileList.splice(idx, 1);
    },
    changeStep() {
      if (this.fileList.length) {
        let requestArr = this.fileList.map(item => {
          // 创建一个 FormData 对象
          const formData = new FormData();
          // 将文件添加到 formData 对象中
          formData.append('file', item.file);
          return postUploadPic(formData);
        });
        Promise.all(requestArr)
          .then(list => {
            let picList = list.map(item => item.data);
            this.form.screenshots = picList;
            this.$emit('input', this.form);
            this.$toast.success(this.$t('picUploadSuccessText'));
            if (this.form.channel_type == 0) {
              // 礼品卡 跳转到确认邮箱
              this.$parent.changeStep('ensureEmail',this.form);
            } else if (this.form.channel_type == 1) {
              // 实体礼物 跳转到地区选择
              this.$parent.changeStep('cityForm',this.form);
            } else {
              // 默认渠道等于好评渠道===都是paypal，直接复制默认渠道的paypal信息
              if(this.form.default_channel_type&&this.form.default_channel_type===2){
                postSubmit({ ...this.form, paypal: this.form.default_paypal }).then(res => {
                  this.$parent.changeStep('thanksAll',this.form);
                });
              }else{
                // paypal 跳转到paypal卡片
                this.$parent.changeStep('paypalForm',this.form);
              }
            }
          })
          .catch(_ => {
            this.$toast.fail(this.$t('picUploadErrorText'));
          });
      } else {
        Dialog.confirm({
          title: this.$t('uploadPic.title'),
          showCancelButton: false,
          confirmButtonText: this.$t('send'),
        }).then(() => {
          // on confirm
        });
      }
    },
    previewPic(pic) {
      ImagePreview([pic]);
    },
  },
};
</script>

<style lang="scss">
.card-uploadPic {
  position: relative;
  width: 100%;
  .card-title {
    font-size: 24px;
    font-weight: 500;
    color: #1a1a1a;
    margin-bottom: 20px;
  }
  .card-text {
    font-size: 17px;
    font-weight: 400;
    color: #1a1a1a;
    margin-bottom: 20px;
  }
  .upload-container {
    display: flex;
    gap: 9px;
    .upload-box {
      width: 110px;
      .upload-btn {
        width: 100px;
        height: 100px;
        padding: 15px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        border: 1px solid #b3b3b3;
        border-radius: 8px;
        &--disabled {
          background-color: #b3b3b3;
        }
        img {
          height: 40px;
        }
      }
      .upload-btn-text {
        font-size: 12px;
        font-weight: 500;
      }
      .upload-text {
        margin-top: 15px;
        font-size: 12px;
        font-weight: 400;
      }
    }
    .van-uploader__preview {
      display: none;
    }
    .review-upload {
      flex: 1;
      max-width: calc(100% - 110px);
      display: flex;
      flex-direction: column;
      gap: 16px;
      .review-upload-pic {
        position: relative;
        // background: linear-gradient(180deg, #ffd814aa, #ffa031aa);
        // border: 2px solid #909090;
        color: #fff;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        padding: 12px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .van-icon {
          position: absolute;
          right: 8px;
          top: 8px;
          width: 22px;
          height: 22px;
          background: #ffffffcf;
          color: #b1afaf;
          border: 1px solid #b1afaf;
          text-align: center;
          line-height: 22px;
          border-radius: 22px;
        }
        img {
          height: 134px;
          width: auto;
          max-width: 100%;
          object-fit: contain;
        }
      }
      .example {
        margin-bottom: 10px;
        color: #595959;
      }
      .review-upload-text {
        font-size: 22px;
        font-weight: 500;
        text-align: center;
      }
    }
  }

  .van-swipe__indicator .van-swipe__indicator-item {
    background-color: #fff;
  }

  .van-swipe__indicator .van-swipe__indicator-item--active {
    background-color: #f4a300; /* 高亮颜色 */
  }
}
</style>
